export const privilegeColors: Record<string, string> = {
  high: 'bg-red-500/20 text-red-300 border-red-500/30',
  medium: 'bg-amber-500/20 text-amber-300 border-amber-500/30',
  low: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30',
};

// A role's privilege level at or above these is badged High / Medium; anything lower is Low.
export const PRIVILEGE_HIGH_MIN = 800;
export const PRIVILEGE_MEDIUM_MIN = 400;

// Names of the real controls the login role picker points users to (Q-1169). The banner's end
// button and the header menu's Testing Console entry render these same constants.
export const END_MASQUERADE_LABEL = 'End Masquerade';
export const TESTING_CONSOLE_LABEL = 'Testing Console';

export function getPrivilegeBadge(level: number): { label: string; color: string } {
  if (level >= PRIVILEGE_HIGH_MIN) return { label: 'High', color: privilegeColors.high };
  if (level >= PRIVILEGE_MEDIUM_MIN) return { label: 'Medium', color: privilegeColors.medium };
  return { label: 'Low', color: privilegeColors.low };
}

/** The badge levels, highest first, with the lowest privilege level that earns each (the badge legend). */
export function getPrivilegeLegend(): Array<{ label: string; min: number; range: string }> {
  return [
    { label: 'High', min: PRIVILEGE_HIGH_MIN, range: `${PRIVILEGE_HIGH_MIN}+` },
    { label: 'Medium', min: PRIVILEGE_MEDIUM_MIN, range: `${PRIVILEGE_MEDIUM_MIN}-${PRIVILEGE_HIGH_MIN - 1}` },
    { label: 'Low', min: 0, range: `under ${PRIVILEGE_MEDIUM_MIN}` },
  ];
}
